(function () {
  function setActiveDot(section, activeIndex) {
    var dots = section.querySelectorAll('[data-featured-collection-target]');

    dots.forEach(function (dot, index) {
      var isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);

      if (isActive) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });
  }

  function getClosestCardIndex(viewport, cards) {
    var viewportCenter = viewport.scrollLeft + viewport.clientWidth / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    cards.forEach(function (card, index) {
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      var distance = Math.abs(viewportCenter - cardCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function initFeaturedCollection(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('.sd-featured-collection');

    sections.forEach(function (section) {
      if (section.dataset.featuredCollectionReady === 'true') {
        return;
      }

      var carousel = section.querySelector('[data-featured-collection-carousel]');
      var cards = Array.prototype.slice.call(section.querySelectorAll('.sd-featured-collection__card'));
      var dots = section.querySelectorAll('[data-featured-collection-target]');

      if (!carousel || cards.length === 0 || dots.length === 0) {
        return;
      }

      var scrollFrame = null;
      section.dataset.featuredCollectionReady = 'true';

      section.addEventListener('click', function (event) {
        var button = event.target.closest('[data-featured-collection-target]');

        if (!button || !section.contains(button)) {
          return;
        }

        var targetIndex = Number(button.dataset.featuredCollectionTarget);
        var targetCard = cards[targetIndex];

        if (!targetCard) {
          return;
        }

        targetCard.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });

        setActiveDot(section, targetIndex);
      });

      carousel.addEventListener('scroll', function () {
        if (scrollFrame) {
          window.cancelAnimationFrame(scrollFrame);
        }

        scrollFrame = window.requestAnimationFrame(function () {
          setActiveDot(section, getClosestCardIndex(carousel, cards));
          scrollFrame = null;
        });
      }, { passive: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFeaturedCollection();
    });
  } else {
    initFeaturedCollection();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFeaturedCollection(event.target);
  });
})();
